// extracted by mini-css-extract-plugin
export default {"mainFooter":"Fotter_mainFooter__lNg4P","Titulo":"Fotter_Titulo__FCPSm","MenuItem":"Fotter_MenuItem__vVc5q"};